import Vue from 'vue'
import _get from 'lodash/get'
import { MerchantModel } from '@/models/UserHierarchy'
import Mtxs from '@/constants/Mutations'
import { getField, updateField } from 'vuex-map-fields'

export const state = {
  settings: [],
  dirtyFields: {},
  saving: 0,
  dirtScore: 0,
  accountDirtyFields: {},
  uploadWidget: null,
  isPrintModeOn: false,
  tableConfig: {},
  tableMeta: {
    page: 1,
    last_page: null,
    per_page: null,
    total: null,
    from: null,
    to: null,
    sortBy: null,
  },
  tableSortDesc: null,
  tableSearchString: '',
  tableFetchOptions: {},
  isSearchOpen: false,
  tableItems: [],
  isTableStale: false,
  prepAvailabilitySelections: [],
  shopSettingsScrollTarget: null,
  shopSettingsScrollTargetTimeout: null,
  isShopSettingsNavbarOpen: false,
  supportScrollTarget: null,
  supportScrollTargetTimeout: null,
  isSupportNavbarOpen: false,
  showDialogOrderExportSettings: false,
  showOrderPrepDatePicker: false,
  orderPrepSearchDate: null,
} // state

export const mutations = {
  [Mtxs.SET_SETTINGS](state, settings) {
    state.settings = settings
  }, // SET_SETTINGS

  [Mtxs.ADJUST_NUM_SAVING](state, delta) {
    state.saving += delta
  }, // ADJUST_NUM_SAVING

  [Mtxs.ADD_TO_ACCT_DIRTIES](state, { field, changes }) {
    Vue.set(state.accountDirtyFields, field.name, changes)
  }, // ADD_TO_DIRTIES

  [Mtxs.REMOVE_FROM_ACCT_DIRTIES](state, fieldName) {
    delete state.accountDirtyFields[fieldName]
  }, // REMOVE_FROM_ACCT_DIRTIES

  [Mtxs.SET_UPLOAD_WIDGET](state, widget) {
    state.uploadWidget = widget
  }, // SET_UPLOAD_WIDGET
  updateField,
} // mutations

export const getters = {
  getAdminSettings: (state) => state.settings,
  getAdminSettingsFields: (state) =>
    state.settings.filter((s) => !_get(s, 'hidden', false)),
  getDirtScore: (state) => state.dirtScore,
  getDirtyFields: (state) => state.dirtyFields,
  getSaving: (state) => state.saving,
  getUploadWidget: (state) => state.uploadWidget,
  getAdminEmail: (state) => _get(state, 'user.email', ''),
  getSortByQuery: (state) => {
    let sortDesc = _get(state, 'tableMeta.sortDesc', false)
    let sortBy = _get(state, 'tableMeta.sortBy', false)
    if (!sortBy) {
      return false
    }
    return sortDesc ? `-${sortBy}` : sortBy
  },
  getField,
} // getters

export const actions = {
  async stageAccountChange({ commit }, { field, changes }) {
    if (changes !== null) {
      // // immediately adjust local shop value
      // dispatch(
      //   'shop/updateShopValue',
      //   { name: field.name, val: changes },
      //   { root: true }
      // )
      commit(Mtxs.ADD_TO_ACCT_DIRTIES, { field, changes })
    } else {
      commit(Mtxs.REMOVE_FROM_ACCT_DIRTIES, field.name)
    }
  }, // stageAccountChange

  async saveAccountSettings({ state, dispatch, commit }) {
    try {
      let isValid = await dispatch('auth/validateSession', null, { root: true })
      if (!isValid) {
        throw new Error('Session expired')
      }
      let dirtyFields = { ...state.accountDirtyFields }
      if (!Object.keys(dirtyFields).length) {
        // nothing to save
        return
      }

      let merchantId = MerchantModel.query().first().id
      MerchantModel.updateModel(merchantId, dirtyFields)
      Object.keys(dirtyFields).forEach((fieldName) => {
        commit(Mtxs.REMOVE_FROM_ACCT_DIRTIES, fieldName)
        dispatch('adjustDirtyValue', -1)
      })
    } catch (error) {
      return Promise.reject(
        new Error(JSON.stringify(error.response ? error.response.data : error))
      )
    }
  }, // saveAccountSettings

  async updateAdminDrawerMiniState(_, { is_admin_drawer_mini }) {
    try {
      let merchantId = MerchantModel.query().first().id
      MerchantModel.updateModel(merchantId, { is_admin_drawer_mini })
    } catch (error) {
      return Promise.reject(
        new Error(JSON.stringify(error.response ? error.response.data : error))
      )
    }
  }, // updateAdminDrawerMiniState

  adjustDirtyValue({ commit }, delta) {
    commit(Mtxs.ADJUST_DIRT_SCORE, delta)
  }, // adjustDirtyValue

  setUploadWidget({ commit }, widget) {
    commit(Mtxs.SET_UPLOAD_WIDGET, widget)
  }, // setUploadWidget
} // actions
